import { useCallback } from "react";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useLiveFormAmplitudeEvents } from "@/features/LiveFormEditor/common/amplitude/useLiveFormAmplitudeEvents";

const NEW_USER_WINDOW_DAYS = 30;
const MS_PER_DAY = 1000 * 60 * 60 * 24;

export type CustomQuestionEvent =
  | AmplitudeEvents.CustomQuestionsModalOpened
  | AmplitudeEvents.ExistingCustomQuestionAdded
  | AmplitudeEvents.CustomQuestionCreationStarted
  | AmplitudeEvents.CustomQuestionCreated
  | AmplitudeEvents.CustomQuestionEditionStarted
  | AmplitudeEvents.CustomQuestionEdited
  | AmplitudeEvents.CustomQuestionSearched
  | AmplitudeEvents.CommunicationPreferencesConfigured
  | AmplitudeEvents.GuestQuestionSuggested
  | AmplitudeEvents.GuestQuestionSuggestionDismissed
  | AmplitudeEvents.GuestQuestionAdded;

export const useCustomQuestionsTracking = (): ((
  event: CustomQuestionEvent,
  extras?: Record<string, unknown>
) => void) => {
  const { logUserActionEvent } = useLiveFormAmplitudeEvents();
  const { currentUser } = useCurrentUserContext();

  return useCallback(
    (event, extras) => {
      const signupMs = currentUser?.createdAtUtc ? new Date(currentUser.createdAtUtc).getTime() : null;
      const isNewUser = signupMs !== null && (Date.now() - signupMs) / MS_PER_DAY <= NEW_USER_WINDOW_DAYS;

      logUserActionEvent(event, { is_new_user: isNewUser, ...extras });
    },
    [currentUser?.createdAtUtc, logUserActionEvent]
  );
};
